
interface Feature {
  title: string;
  desc: string;
  icon: string;
}

interface Business {
  title: string;
  features: Feature[];
  image: string;
}

interface BusinessFeaturesProps {
  business: Business;
}

export default function BusinessFeatures({ business }: BusinessFeaturesProps) {
  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-sm font-semibold tracking-widest text-teal-600 uppercase">Core Capabilities</span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mt-3">核心能力</h2>
          <p className="text-base text-gray-500 mt-3 max-w-2xl mx-auto">
            围绕{business.title}领域，我们构建了完整的技术能力与服务体系
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {business.features.map((feature, idx) => (
            <div
              key={idx}
              className="group bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-teal-100"
            >
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 bg-teal-50 rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-100 transition-colors">
                  <i className={`${feature.icon} text-2xl text-teal-600`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{feature.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 业务图片展示 */}
        <div className="mt-14 rounded-2xl overflow-hidden shadow-lg">
          <div className="relative h-80 lg:h-96">
            <img
              src={business.image}
              alt={business.title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            <div className="absolute bottom-8 left-8 right-8">
              <div className="flex items-center gap-3">
                <div className="w-1 h-10 bg-teal-500 rounded-full"></div>
                <div>
                  <p className="text-white font-bold text-lg">{business.title}</p>
                  <p className="text-white/70 text-sm">以技术驱动产业升级，以智能赋能数字化转型</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
